<mat-card class="report-card" (click)="viewReport()">
  <mat-card-content>
    <mat-card-title>
      <div class="row">
        <div class="col-10 pr-0">
          <h5 class="prop-address">
            <!-- {{ report.streetAddress }}  -->
            {{ report.reportName ? report.reportName.split(',')[0] : report.streetAddress }}
            <br />
            <span class="sub-address">{{ report.city }}, {{ report.state }} {{ report.zip }} </span>
          </h5>
        </div>
        <div class="col-2">
          <button mat-icon-button [matMenuTriggerFor]="menu" (click)="$event.stopPropagation()">
            <mat-icon>more_vert</mat-icon>
          </button>
        </div>
      </div>
      <div class="instant-cma" *ngIf="report.reportCategory == 'instantCMA' && userRole !== 'investor'">
        Instant CMA
      </div>
      <div class="custom-cma" *ngIf="report.reportCategory == 'customCMA' && userRole !== 'investor'">Custom CMA</div>
      <div class="lead-cma" *ngIf="report.reportCategory == 'leadCMA' && userRole !== 'investor'">Lead CMA</div>
      <div class="smart-report" *ngIf="report.reportCategory == 'smartReport' && userRole !== 'investor'">
        Smart Research
      </div>
      <div>
        <div class="row mb-2" style="min-height: 90px">
          <div class="col-4 pr-0">
            <img
              *ngIf="report.imgUrl"
              class="img-fluid mx-auto report-image"
              [src]="
                report?.imgUrl
                  ? listingImageBaseUrl + '?ListingId=' + (report.listingId || 'null') + '&imageName=1'
                  : listingImageBaseUrl + '?ListingId=null&ImageName=1&height=180'
              "
            />
          </div>
          <div class="col-8">
            <div class="row">
              <div class="col-6 prop-items">
                <p class="prop-value">
                  <span class="prop-label">Bed: </span>
                  <b>{{ (report.beds | number) || '-' }}</b>
                </p>
              </div>
              <div class="col-6 prop-items">
                <p class="prop-value">
                  <span class="prop-label">Baths: </span>
                  <b>{{ (report.baths | number) || '-' }}</b>
                </p>
              </div>
            </div>

            <div class="row">
              <div class="col-6 prop-items pr-0">
                <p class="prop-value">
                  <span class="prop-label">GLA: </span>
                  <b
                    >{{ (report.livingArea | number) || '-' }}
                    <small>sq.ft</small>
                  </b>
                </p>
              </div>
              <div class="col-6 prop-items">
                <p class="prop-value">
                  <span class="prop-label">Stories: </span>
                  <b>{{ (report.stories | number) || '-' }}</b>
                </p>
              </div>
            </div>

            <div class="row">
              <div class="col-6 pr-0 prop-items">
                <p class="prop-value">
                  <span class="prop-label">Year Built: </span>
                  <b>{{ report.yearBuilt || '-' }}</b>
                </p>
              </div>
              <div class="col-6 prop-items">
                <p class="prop-value">
                  <span class="prop-label">DOM: </span>
                  <b>{{ (report.daysonMarket | number) || '-' }}</b>
                </p>
              </div>
            </div>
          </div>
        </div>
        <div class="report-cont">
          <div class="row mb-2">
            <div class="col-12">
              <div class="prop-items">
                <p class="prop-value">
                  <span class="prop-label"
                    >{{
                      report?.reportCategory == 'smartReport'
                        ? report?.cmaReportData?.selectedValueType == 'CUSTOM_VALUE'
                          ? 'Your Value'
                          : report?.cmaReportData?.selectedValueType == 'SALES_COMPARISON_VALUE'
                          ? 'Model Adjusted Value'
                          : 'Starting Value'
                        : 'Home Value'
                    }}
                    :</span
                  >
                  <b *ngIf="report?.cmaReportData?.homeValue || report?.cmaReportData?.selectedValue">
                    ${{
                      report?.cmaReportData?.selectedValue
                        ? (report?.cmaReportData?.selectedValue | number)
                        : (report?.cmaReportData?.homeValue | number)
                    }}
                  </b>
                  <b *ngIf="!report?.cmaReportData?.homeValue && !report?.cmaReportData?.selectedValue"> - </b>
                </p>
              </div>
            </div>
            <div class="col-12">
              <div class="row">
                <div class="col-12 prop-items pr-0">
                  <p class="prop-value">
                    <span class="prop-label">Number of comps : </span>
                    <b *ngIf="report?.cmaReportData?.noOfComps">
                      {{ report?.cmaReportData?.noOfComps }}
                    </b>
                    <b *ngIf="!report?.cmaReportData?.noOfComps"> - </b>
                  </p>
                </div>
              </div>
            </div>
            <div class="col-12" *ngIf="report?.reportCategory != 'smartReport'">
              <div class="row">
                <div class="col-12 prop-items pr-0">
                  <p class="prop-value">
                    <span class="prop-label">Prepared for : </span>
                    <b *ngIf="report.clientName">{{ report.clientName }} </b>
                    <b *ngIf="!report.clientName">{{ report.clientName }} </b>
                  </p>
                </div>
              </div>
            </div>
            <div class="col-12">
              <div class="row">
                <div class="col-12 prop-items pr-0">
                  <p class="prop-value">
                    <span class="prop-label">Created on : </span>
                    <b *ngIf="report.cmaReportCreatedDate"
                      >{{ report.cmaReportCreatedDate | date: 'MMM d, y, h:mm a' }}
                    </b>
                    <b *ngIf="!report.cmaReportCreatedDate"> -- </b>
                  </p>
                </div>
              </div>
            </div>
            <div class="col-12">
              <div class="row">
                <div class="col-12 prop-items pr-0">
                  <p class="prop-value">
                    <span class="prop-label">Status : </span>
                    <b class="success" *ngIf="report.status == 'created'"> Success </b>
                    <b class="insufficient" *ngIf="report.status == 'failed'"> Failed </b>
                  </p>
                </div>
              </div>
            </div>
            <div class="col-12">
              <div class="row">
                <div class="col-12 prop-items pr-0">
                  <p class="prop-value">
                    <span class="prop-label">Source : </span>
                    <b>{{ report.mls ? report.mls : 'Public' }}</b>
                  </p>
                </div>
              </div>
            </div>
            <div
              class="col-12"
              *ngIf="
                (!report?.connectedAgentId && report?.createdById !== userId && userRole !== 'companyManager') ||
                (userRole === 'companyManager' && report?.sharedWith?.includes(userId))
              "
            >
              <div class="row">
                <div class="col-12 prop-items pr-0">
                  <p class="prop-value shared-txt">* Shared with me</p>
                </div>
              </div>
            </div>

            <div
              class="col-12"
              *ngIf="
                (userRole === 'companyManager' && !report?.connectedAgentId && report?.createdById !== userId) ||
                (report?.connectedAgentId && report?.createdById !== userId)
              "
            >
              <div class="row">
                <div class="col-12 prop-items pr-0">
                  <p class="prop-value shared-txt">* Generated by customer</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </mat-card-title>
  </mat-card-content>
</mat-card>

<mat-menu #menu="matMenu">
  <button
    mat-menu-item
    (click)="deleteReport()"
    *ngIf="!isInvestor && !this.cmaState?.filterValValue?.coBrandedWithMe && report?.createdById == userId"
  >
    <mat-icon class="mr-1">delete</mat-icon> Delete
  </button>

  <button
    mat-menu-item
    *ngIf="report?.createdById == userId && userRole != 'loanOfficer' && userRole != 'investor'"
    (click)="editReport()"
  >
    <mat-icon class="mr-1">edit</mat-icon> Edit
  </button>
  <app-share-cma-report-dialogbox
    *ngIf="reportOutput.status == 'created'"
    [shareReportInput]="reportOutput"
    class="ard-Share-button"
  ></app-share-cma-report-dialogbox>
  <!-- <button *ngIf="reportOutput.status == 'created'" mat-menu-item (click)="downloadReport()">

  <button *ngIf="reportOutput.status == 'created'" mat-menu-item (click)="downloadReport()">
    <mat-icon class="mr-1">download</mat-icon> Download
  </button> -->
</mat-menu>
